module.exports = __webpack_public_path__ + "static/media/8H.a641ee9c.svg";